import React, { Component } from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import '../../Assets/EnsembleStyles/TitleBar.css';

class InActive extends Component {

  constructor(props) {
    super(props);
    this.state = {
      Logout: false,
      Logout_button_state: false,
      time: {},
      seconds: 120,
      EnsembleLoginUrl: '',
      EnsembleHomePage: ''
    };
    this.LogoutButton = this.LogoutButton.bind(this);
    this.timer = 0;
    this.startTimer = this.startTimer.bind(this);
    this.countDown = this.countDown.bind(this);
  }

  secondsToTime(secs) {
    let hours = Math.floor(secs / (60 * 60));

    let divisor_for_minutes = secs % (60 * 60);
    let minutes = Math.floor(divisor_for_minutes / 60);

    let divisor_for_seconds = divisor_for_minutes % 60;
    let seconds = Math.ceil(divisor_for_seconds);

    let obj = {
      "h": hours,
      "m": minutes,
      "s": seconds
    };
    return obj;
  }

  componentDidMount() {
    let EnsembleLoginUrl = '', HomePage = '';
    var Is_Onpremise = (this.props.OnPremises !== undefined && this.props.OnPremises !== null) ? this.props.OnPremises : false;
    if(Is_Onpremise){
      let pName = window.location.pathname.substring(1);
      let ensRoot = pName.indexOf('/');
      pName = pName.substring(0, ensRoot);
      EnsembleLoginUrl = window.location.protocol + "//" + window.location.host + "/" + pName + "/LoginPage.aspx";
      
      var PageUrl = window.location.href.split("?Page=")[1];
      var ensPageRoot = PageUrl.indexOf('#');
      HomePage = PageUrl.substring(0, ensPageRoot);
    }
    var WarningTime = this.state.seconds;
    var E_LogoffWarningTime = localStorage.getItem("AutoLogoffWarningTime");
    if(E_LogoffWarningTime !== undefined && E_LogoffWarningTime !== null && E_LogoffWarningTime !== ""){
      WarningTime = Number(E_LogoffWarningTime);
    }
    let timeLeftVar = this.secondsToTime(WarningTime);
    this.setState({ time: timeLeftVar, IsOnpremise: Is_Onpremise, EnsembleLoginUrl: EnsembleLoginUrl, EnsembleHomePage: HomePage });
  }

  startTimer() {
    if (this.timer === 0 && this.state.seconds > 0) {
      this.timer = setInterval(this.countDown, 1000);
    }
  }

  countDown() {
    // Remove one second, set state so a re-render happens.
    let seconds = this.state.seconds - 1;
    this.setState({
      time: this.secondsToTime(seconds),
      seconds: seconds,
    });

    // Check if we're at zero.
    if (seconds === 0) {
      clearInterval(this.timer);
    }
  }

  LogoutButton() {
    this.setState({
      Logout_button_state: true
    });
  }

  render() {
    var Extend_Session = this.props.Extend_Session;
    let { Logout_button_state, time } = this.state

    if (Logout_button_state === true) {
      if(this.state.IsOnpremise)
      {
        window.location.replace(this.state.EnsembleLoginUrl);
      }else{
        return <Redirect to={"/PropertyMangerLogout"} />
      }
    }
    if (time.m === 0 && time.s === 0) {
      if(this.state.IsOnpremise)
      {
        window.location.replace(this.state.EnsembleLoginUrl+"?IsLogOffFromReact=True&Page="+this.state.EnsembleHomePage);
      }else{
        return <Redirect to={"/PropertyMangerLogout"} />
      }
    }

    return (
      <div className="delete_confirmation_Modal">
        {this.startTimer()}
          <div id="idConfirm1_popupTitle" className="AutoLogOff_Title">
            <table cellpadding="0" cellspacing="0" style={{"border": "5", "height":"100%"}}>
              <tbody>
                <tr>
                  <td valign="middle" align="left" style={{"width":"450px"}} className="logoffpopup"><b>Tracer Ensemble</b></td>
                  <td valign="middle" align="right" style={{"padding-left":"15px"}}><div className="TModalPopupCloseIcon" onClick={this.LogoutButton} /></td>
                </tr>
              </tbody>
            </table>
          </div>
          <div id="idConfirm1_popupBody" className="AutoLogOff_Body">
            <div>
              <table width="100%" border="0" cellpadding="0" cellspacing="0">
                <tbody>
                  <tr style={{"height":"100%"}}>
                    <td align="left" colspan="2" className="logoffpopup">Your session is about to expire in {this.state.time.m} Min and {this.state.time.s} Sec. Click 'Extend Session' to remain logged into Tracer Ensemble.</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div id="idConfirm1_popupFooter" className="AutoLogOff_Footer">
            <table width="100%" border="0" cellpadding="0" cellspacing="0">
              <tbody>
                <tr>
                  <td align="right" colspan="2">
                    <table>
                      <tbody>
                        <tr>
                          <td align="right">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr>
                                  <td>
                                    <table width="100%" cellpadding="0" cellspacing="0">
                                      <tbody>
                                        <tr>
                                          <td style={{"width":"6px"}} align="left" className="curveleft"><div>&nbsp;</div></td>
                                          <td align="left" className="curved"><div name="idConfirm1_yesButton" id="idConfirm1_yesButton" onClick={() => Extend_Session('yes')} className="logoffpopup">Extend Session</div></td>
                                          <td style={{"width":"6px"}} align="left" className="curveright"><div>&nbsp;</div></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                  <td style={{"width":"20px"}}>&nbsp;</td>
                                  <td>
                                    <table width="100%" cellpadding="0" cellspacing="0">
                                      <tbody>
                                        <tr>
                                          <td style={{"width":"6px"}} align="left" className="curveleft"><div>&nbsp;</div></td>
                                          <td align="left" className="curved"><div name="idConfirm1_noButton" id="idConfirm1_noButton" onClick={this.LogoutButton} className="logoffpopup">Logout</div></td>
                                          <td style={{"width":"6px"}} align="left" className="curveright"><div>&nbsp;</div></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        
        {/* <ModalHeader toggle={this.toggle} className="Inactive_modal_header"> Tracer Ensemble</ModalHeader>
        <div className="Inactive_content">
          <p>Your session is about to expire in {this.state.time.m} Min and {this.state.time.s} Sec. Click 'Extend Session' to remain logged into Tracer Ensemble.</p>
        </div>
        <FormGroup row >
          <Col sm={{ size: 12 }}>
            <Button className="btn-black btn-md ChangeLimits_Applybtn" onClick={() => Extend_Session('yes')}>Extend Session</Button>
            <Button className="btn-black btn-md ChangeLimits_Cancelbtn" onClick={this.LogoutButton}> Logout </Button>
          </Col>
        </FormGroup> */}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    OnPremises: state.authService.IsOnPremise
  };
};
export default connect(mapStateToProps, null)(InActive);

